(ns renolit-roofing-service.layout.display-item.impl
  (:require [renolit-roofing-service.layout.display-item :as layout.display-item]
            [renolit-roofing-service.localization :refer [t]]))

(defmethod layout.display-item/display-item-component :text
  [{:keys [multi-line] :as opts}]
  (let [value (layout.display-item/get-value opts)]
    [:span.display-item__value
     (cond-> {}
       multi-line
       (assoc :class "display-item__multi-line-text"))
     (or value (t [:common/no-data]))]))

(defmethod layout.display-item/display-item-component :custom
  [{:keys [component] :as opts}]
  (let [value (layout.display-item/get-value opts)]
    (if value
      [component value]
      (t [:common/no-data]))))
